export default class TokensNotRejectedError extends Error {
};
